import React from "react";
import styles from "../../LocationForm.module.css";
import {ValidationResult} from "../../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator} from "../../../../../../elements/validator/Validator";
import {Section} from "../../../../../../elements/section/Section";
import {EnquiryProvider} from "../../../../../../../api/generated";
import {useAppSelector} from "../../../../../../../app/hooks";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../LocationForm";
import {ValidatedSelectField} from "../../../../../../elements/validator/component/ValidatedSelectField";
import {
    allEnquiryProviderOptions
} from "../../../../../assistant/modal/createAndUpdate/components/util/enquiryProviderUtil";
import {Dragon2000Fields} from "./fields/Dragon2000Fields";
import {Em2Fields} from "./fields/Em2Fields";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const EnquiryInformation = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus
  }: Props<T, W>) => {

    const enquiryProvider = useAppSelector(selectionProvider.enquiryProvider)

    const getRequiredFields = () => {
        switch (enquiryProvider) {
            case EnquiryProvider.Dragon2000:
                return <Dragon2000Fields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            case EnquiryProvider.Em2:
                return <Em2Fields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            default:
                return <></>
        }
    }

    return <Section title={"Enquiry Information"}>
        <div className={styles.fieldsLine}>
            <ValidatedSelectField<EnquiryProvider, T>
                onChange={(v) => updateRequest({enquiryProvider: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'enquiryProvider'}
                selector={selectionProvider.enquiryProvider}
                validator={NotEmptyStringValidator}
                label={'Enquiry Platform Provider'}
                getMessage={getMessage}
                options={allEnquiryProviderOptions}
            />
        </div>
        {getRequiredFields()}
    </Section>
}
